import { render } from "./MenuPopover.vue?vue&type=template&id=3d20fed2"
import script from "./MenuPopover.vue?vue&type=script&lang=js"
export * from "./MenuPopover.vue?vue&type=script&lang=js"
script.render = render

export default script